import React from 'react';
import { PostsEditor } from './PostsEditor';
import { PostFormTypes, PostTypes } from '../Post.types';
import { SonForm } from '../../../Form2';

export type PostsEditorWithUpload = {
  form: SonForm<PostFormTypes>;
  type: PostTypes;
  postId: string;
  autoFocus?: boolean;
};

/**
 * Wrapper for the Posts RichText Editor with Upload
 */
export function PostsEditorWithUpload({ form, type, autoFocus, postId }: PostsEditorWithUpload) {
  return (
    <PostsEditor form={{ ...form, url: form.url }} type={type} autoFocus={autoFocus} uuid={postId} />
  );
}
